import clsx from 'clsx'
import React, { ReactNode } from 'react'

import s from './styles.module.scss'

interface SelectableButtonProps {
  isDisabled: boolean
  onClick: () => void
  isSelected: boolean
  content: ReactNode
}

const SelectableButton = (props: SelectableButtonProps) => {
  const { isDisabled, isSelected, content, onClick } = props

  return (
    <div
      className={clsx(s.buttonGroupItem, {
        [s.buttonGroupItemSelected]: !isDisabled && isSelected,
        [s.buttonGroupDisabled]: isDisabled,
      })}
      onClick={onClick}
    >
      {content}
    </div>
  )
}

export default SelectableButton
